package modysy.simulation.pp

import modysy.model.{Agent, GameObject}
import modysy.simulation.Behaviours

/** Models an agents state inside a population protocol.
  *
  * @param name               unique name of the state used for identifying possibly later for displaying to the user
  * @param deducedAgentColor  color of agents with this state, see view.Color
  * @param output             output of this state
  * @param deducedAgentRadius radius of circular agents with this state
  */
case class State(
    name: String,
    deducedAgentColor: String,
    output: Output,
    behaviour: (Agent, Seq[GameObject]) => Unit,
    deducedAgentRadius: Double = 50
) {

  def apply(
      name: String,
      deducedAgentColor: String,
      output: Output,
      deducedAgentRadius: Double = 50
  ): State = {
    State(
      name,
      deducedAgentColor,
      output,
      Behaviours.noBehaviour(),
      deducedAgentRadius
    )
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/pp/State.scala